import config from '@/helpers/config';
import axios from 'axios';

export default $axios => {
    return {
        $axios,

        async autosignin(form) {
            return await $axios.post(`${config.originalApiUrl}/clients/autosignin`, form);
        },

        async confirm(form) {
            return await $axios.post(`${config.originalApiUrl}/confirmation`, form);
        },

        async confirmEmail() {
            return await $axios.post(`${config.apiUrl}/self/send-confirm-mail`, {
                type_app: 'web_client'
            });
        },

        async getWorkload({
            service_id,
            office_id
        }) {
            const officeQuery = office_id ? `&office_id=${office_id}` : '';

            return await axios.get(`${config.apiUrl}/workload?service_id=${service_id}${officeQuery}`, {
                headers: {
                    'X-Features': "NEW_WORKLOAD,NEW_SERVICES"
                }
            });
        }
    };
};